export default theme => ({
  vertical__select: {
    width: '100%',
  },
  vertical__option: {
    padding: '5px 15px',
    color: theme.palette.text.bold,
    fontSize: '18px',
  },
});
